import { render, staticRenderFns } from "./Product_discount.vue?vue&type=template&id=ee454ffe&scoped=true&"
import script from "./Product_discount.vue?vue&type=script&lang=js&"
export * from "./Product_discount.vue?vue&type=script&lang=js&"
import style0 from "./Product_discount.vue?vue&type=style&index=0&id=ee454ffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee454ffe",
  null
  
)

export default component.exports